import Paginacao from "../types/paginacao";
import User from "../types/user";
import warehouseClient from "../types/warehouseClient";
import api, { fetchData } from "./api";

export interface UsuarioApiResponse {
    data: UsuarioResponse
    success: boolean;
    message?: string;
}

export interface UsuarioResponse {
    id: number;
    email: string;
    fullName: string;
    username: string;
    password: string;
    accountExpired: boolean,
    accountLocked: boolean,
    passwordExpired: boolean,
    enabled: boolean,
    secUserSecRoles: SecUserSecRole[],
    worksTo: warehouseClient[]
}

export interface UsuarioVM {

}

export interface SecUserSecRole {
    secRole: {
      id: number;
      authority: string;
    };
  }

export interface ApiValidationError {
    type: string;
    title: string;
    status: number;
    errors: Record<string, string[]>;
    traceId: string;
}


export interface UsuarioApiCreateResponse {
    data: UsuarioResponse;
    success: boolean;
    message?: string;
    errors?: Record<string, string[]>;
}

export interface UsuarioPostVM {
    id: number;
    fullName: string;
    userName: string;
    email: string;
    password: string;
    enabled: boolean;
    accountExpired: boolean;
    accountLocked: boolean;
    passwordExpired: boolean;
    confirmPassword: string;
    roleIds: number[];
    wareHouseClientIds: number[];
}

export interface UsuarioPutVM {
    id: number;
    userName?: string;
    password?: string;
    email?: string;
    fullName?: string;
    enabled?: boolean;
    roleIds?: number[];
    wareHouseClientIds?: number[];
    accountExpired?: boolean;
    accountLocked?: boolean;
    passwordExpired?: boolean;
}

export const getListaUsuarios = async () => {
    try {
        const endpoint: string = "/Usuario/all";
        const response = await fetchData<User>(endpoint, {});
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar lista de usuários:", error);
        throw error;
    }
};

export const getUsuarios = async () => {
    try {
        const endpoint: string = "/Usuario/all";
        const response = await fetchData<User>(endpoint, {});
        return response
    } catch (error) {
        console.error("Erro ao buscar lista de usuários:", error);
        throw error;
    }
};

export const getUsuariosPaginated = async (
    paginacao: Paginacao
  ) => {
    try {
      const endpoint: string = '/Usuario/all/paginado';
      const params: Record<string, any> = {
        pageNum: paginacao.pageNum + 1,
        quantityPerPage: paginacao.quantityPerPage,
      };

      // Adicionar searchTerm se existir
      if (paginacao.searchTerm && paginacao.searchTerm.trim() !== '') {
        params.searchTerm = paginacao.searchTerm.trim();
      }

      // Adicionar sortModel se existir
      if (paginacao.sortModel && paginacao.sortModel.length > 0) {
        params.sortModel = paginacao.sortModel;
      }

      // Adicionar filterModel se existir
      if (paginacao.filterModel && paginacao.filterModel.length > 0) {
        params.filterModel = { items: paginacao.filterModel };
      }

      const response = await fetchData<User>(endpoint, params);

      return response;
    } catch (error) {
      console.error('Erro ao buscar lista de usuários:', error);
      throw error;
    }
};

export const getUsuarioById = async (id: number) => {
    try {
        const response = await api.get<UsuarioApiResponse>(`/Usuario/${id}`);
        return response.data; 
    } catch (error) {
        console.error(`Erro ao buscar usuário com ID ${id}`, error);
        throw error;
    }
};

export const updatePasswordService = async (currentPassword: string, newPassword: string,
    usuarioId: number): Promise<UsuarioApiResponse> => {
    try {
        const endpoint: string = "/Usuario/updatePassword";
        const body = {
            currentPassword: currentPassword,
            newPassword: newPassword, 
            usuarioId: usuarioId,
        };

        const response = await api.put<UsuarioApiResponse>(endpoint, body);

        return response.data;
    } catch (error) {
        console.error("Erro ao atualizar a senha do usuário:", error);
        throw error;
    }
};

export const createUsuario = async (usuario: UsuarioVM) => {
    try {
        const response = await api.post<UsuarioApiCreateResponse>("/Usuario", usuario);
        return response.data;
    } catch (error) {
        console.error("Erro ao criar usuário:", error);
        throw error;
    }
};

export const updateUsuario = async (id: number, usuario: UsuarioPutVM) => {
    try {
        const response = await api.put<UsuarioApiResponse>(`/Usuario/update/${id}`, usuario);
        return response.data;
    } catch (error) {
        console.error(`Erro ao atualizar usuário com ID ${id}:`, error);
        throw error;
    }
};

export const deleteUsuario = async (id: number) => {
    try {
        await api.delete(`/Usuario/${id}`);
        return true;
    } catch (error) {
        console.error(`Erro ao excluir usuário com ID ${id}:`, error);
        return false;
    }
};
